import { api } from './api';

export interface AgentResponse<T = Record<string, unknown>> {
  output: T;
  model: string;
  costCents: number;
  citations: Array<{ kind: string; id: string }>;
  /** Id of the saved AI result (visible on the AI Results page). */
  resultId?: string;
}

export const agentsApi = {
  prospect: async (workspaceId: string, prompt: string) => {
    const r = await api.post<AgentResponse<{ contacts: Array<{ id: string; reason: string }> }>>('/api/agents/prospect', { workspaceId, prompt });
    return r.data;
  },
  keigoCompose: async (input: {
    workspaceId: string;
    /** Optional. When omitted, backend falls back to signal.contact_id
     *  or signal.account_id (account-level outreach with 御中 salutation). */
    contactId?: string;
    signalId?: string;
    register: 'first_formal' | 'follow_up' | 'introduced' | 'warm';
  }) => {
    const r = await api.post<AgentResponse<{ subject: string; body: string }>>('/api/agents/keigo-compose', input);
    return r.data;
  },
  replyCoach: async (input: { workspaceId: string; threadId: string; inboundBody: string }) => {
    const r = await api.post<AgentResponse<{ subject: string; body: string }>>('/api/agents/reply-coach', input);
    return r.data;
  },
  dealCoach: async (input: { workspaceId: string; dealId: string }) => {
    const r = await api.post<
      AgentResponse<{ healthScore: number; nextBestActions: string[]; rationale: string }>
    >('/api/agents/deal-coach', input);
    return r.data;
  },
  signalSummary: async (input: { workspaceId: string; sinceDays: number; lang: string }) => {
    const r = await api.post<AgentResponse<{ summary: string }>>('/api/agents/signal-summary', input);
    return r.data;
  },
  salesQa: async (workspaceId: string, prompt: string) => {
    const r = await api.post<AgentResponse<{ answer: string }>>('/api/agents/sales-qa', { workspaceId, prompt });
    return r.data;
  },
};
